import { calcWidth } from "../helpers/styles";
export var getFieldLayoutSize = function (size, widthSize) {
    var selectedSize = size || widthSize;
    return typeof selectedSize === 'string' ? selectedSize : calcWidth(selectedSize);
};
//# sourceMappingURL=getFieldLayoutSize.js.map